var render, staticRenderFns
import script from "./WdmParameters.vue?vue&type=script&lang=js&"
export * from "./WdmParameters.vue?vue&type=script&lang=js&"
import style0 from "./WdmParameters.vue?vue&type=style&index=0&id=2c94b97d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports